// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@-webkit-keyframes _2G0gM{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}@keyframes _2G0gM{5%{opacity:1}50%{opacity:.35}95%{opacity:1}}.oKw_R path:not([fill=white]),.oKw_R._2djy4 path[fill=white]{fill:#f7d261}._1mEV7 path:not([fill=white]),._1mEV7._2djy4 path[fill=white]{fill:#1ea98c}._2HsLn path:not([fill=white]),._2HsLn._2djy4 path[fill=white]{fill:#f9707e}._2hV4w{height:13px;left:8px;overflow:visible;position:absolute;top:1px;width:auto}.efBC3{fill:#fff!important}._2CWog{fill:#f7d261}._2_7_I{fill:#1ea98c}._3uAqI{fill:#f9707e}._3hjpb{color:#f5f9ff;font-size:12px;font-size:1.2rem;font-weight:700;left:50%;line-height:18px;line-height:1.8rem;position:absolute;top:13px;-webkit-transform:translate(-50%);-ms-transform:translate(-50%);transform:translate(-50%)}", ""]);
// Exports
exports.locals = {
	"reading__badge--high": "oKw_R",
	"reading__badge--active": "_2djy4",
	"reading__badge--normal": "_1mEV7",
	"reading__badge--low": "_2HsLn",
	"reading__icon": "_2hV4w",
	"reading__icon--active": "efBC3",
	"reading__icon--high": "_2CWog",
	"reading__icon--normal": "_2_7_I",
	"reading__icon--low": "_3uAqI",
	"reading__text": "_3hjpb",
	"fading": "_2G0gM"
};
module.exports = exports;
